// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ua4O","colMin":"styles_colMin__20s8s"};